<div class="component-wrapper">
    <form [formGroup]="contactDataForm">

        <section-info [overrideTitle]="'contact-data.antragstellerTitle' | translate" [attr.aria-label]="'contact-data.antragstellerTitle' | translate"></section-info>
        <kontakt class="antragsteller-input" [form]="contactDataForm.Antragsteller"
            kontakttyp="antragsteller" [isAntragsteller]="true" [disabled]="false" [isRequired]="true" [isWeitererAnsprechpartnerChecked]="false"></kontakt>
        
        <kendo-formfield class="informationsquelle">
            <div class="d-flex mb-1">
                <kendo-label class="form-label" [for]="informationsquelle" text="{{'contact-data.informationSourceText' | translate}} *" [title]="'contact-data.informationSourceText' | translate" [infotooltip]="'kontaktdaten.informationsquelle'"></kendo-label>
            </div>
            <kendo-combobox formControlName="informationsquelle" [valuePrimitive]="true" #informationsquelle
                [allowCustom]="false" [data]="informationsquelleList" [valueField]="'Value'"
                [textField]="'Description'" [appinfotext]="'kontaktdaten.informationsquelle'" kendoDropDownFilter>
            </kendo-combobox>
        </kendo-formfield>
    </form>
</div>